import React from 'react';
import { Box, Paper, Typography, Skeleton, Button } from '@mui/material';

const ContentDisplay = ({ 
  width = '100%', 
  height = 'auto', 
  title, 
  subtitle,
  image,
  onClick,
  buttonText,
  isLoading = false,
  variant = 'default',
  sx = {}
}) => {
  if (isLoading) {
    return (
      <Box sx={{ width, height }}>
        <Skeleton 
          variant="rectangular" 
          width={width} 
          height={height}
          sx={{ borderRadius: 2 }}
        />
      </Box>
    );
  }

  return (
    <Paper
      elevation={3}
      onClick={onClick}
      sx={{
        width,
        height,
        background: image 
          ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5))`
          : gradients[variant],
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': onClick ? {
          transform: 'translateY(-2px)',
          boxShadow: 6
        } : {},
        borderRadius: 2,
        overflow: 'hidden',
        padding: 2,
        position: 'relative',
        ...sx
      }}
    >
      {image && (
        <img 
          src={image}
          alt={title || 'Promotion'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: height === 'auto' ? 'contain' : 'cover',
            zIndex: 0
          }}
        />
      )}
      
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          color: 'white',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
          backgroundColor: 'rgba(0,0,0,0.3)',
          padding: 1,
          borderRadius: 1
        }}
      >
        {title && (
          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom
            sx={{ 
              fontWeight: 'bold',
              fontSize: { xs: '1rem', sm: '1.25rem' },
              lineHeight: 1.2,
              mb: subtitle ? 1 : 0
            }}
          >
            {title}
          </Typography>
        )}
        
        {subtitle && (
          <Typography 
            variant="body2"
            sx={{ 
              fontSize: { xs: '0.875rem', sm: '1rem' },
              lineHeight: 1.2,
              mb: buttonText ? 2 : 0,
              px: 1
            }}
          >
            {subtitle}
          </Typography>
        )}

        {buttonText && (
          <Button 
            variant="contained" 
            color="primary"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onClick?.();
            }}
            sx={{
              mt: 1,
              px: 2,
              borderRadius: 5,
              textTransform: 'none',
              boxShadow: 2,
              backgroundColor: 'rgba(255,255,255,0.9)',
              color: '#000',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,1)'
              }
            }}
          >
            {buttonText}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

const gradients = {
  default: 'linear-gradient(45deg, #2196f3, #21cbf3)',
  primary: 'linear-gradient(45deg, #3f51b5, #7986cb)',
  secondary: 'linear-gradient(45deg, #9c27b0, #ba68c8)',
  accent: 'linear-gradient(45deg, #ff4081, #f48fb1)'
};

export default ContentDisplay;
